import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector, shallowEqual } from 'react-redux';

import { selectElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';

import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { usePartner } from 'components/app/routes/usePartner';
import { useIsLoginEnabledJourney } from './useIsLoginEnabledJourney';
import { PARTNERS } from 'config/app-config';

export const useIsEVQuote = () => {
  const isLoginEnabledJourney = useIsLoginEnabledJourney({
    exclude: [PARTNERS.NONDOMESTIC_TRANSFER]
  });
  const { releaseEvQuote, releaseEvQuoteVoiceSales } = useFlags();
  const { isDSJourney } = usePartner();
  const { isEV } = useCurrentProduct();
  const electricVehicle = useSelector(selectElectricVehicle, shallowEqual);
  const isAllowedJourney =
    (!!releaseEvQuote && isDSJourney) ||
    (!!releaseEvQuoteVoiceSales && isLoginEnabledJourney);

  const isEVBeforeQuote = !!electricVehicle && !!isAllowedJourney;

  return {
    isEVQuote: isEV && isEVBeforeQuote,
    isEVBeforeQuote
  };
};
